import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";

import { ToastService } from "@dffedb/ui";

import { TilknytForbrugerViewModel } from "./model/tilknyt-forbruger.view-model";
import { TilknytForbrugerSandbox } from "./tilknyt-forbruger.sandbox";

@Component({
    selector: "e-forsyning-tilknyt-forbruger",
    templateUrl: "./tilknyt-forbruger.component.html"
})
export class TilknytForbrugerComponent implements OnInit {
    public vm$: Observable<TilknytForbrugerViewModel>;
    public kolonneOverskifter = ["navn", "adresse", "forbrugernr", "forsyning", "fjern"];
    public form: UntypedFormGroup;
    public errorMessage = "";

    constructor(private readonly tilknytForbrugerSandbox: TilknytForbrugerSandbox, private readonly toastService: ToastService) {}

    public ngOnInit(): void {
        this.hentData();
    }

    public opretTilknytning(forsyningId: string, mailadresse: string, kodeord: string): void {
        this.tilknytForbrugerSandbox
            .opretTilknytning(forsyningId, mailadresse, kodeord)
            .then(() => {
                this.toastService.visInfo("Tilknytning oprettet.");
                this.errorMessage = "";
                this.hentData();
            })
            .catch((e) => {
                this.toastService.visFejl(e.friendlyMessage);
                this.errorMessage = e.friendlyMessage;
            });
    }

    public async sletTilknytning(tilknytning: any): Promise<void> {
        try {
            await this.tilknytForbrugerSandbox.sletTilknytning(tilknytning.tilknytningId);
            this.hentData();
        } catch (e) {
            this.toastService.visFejl(e.friendlyMessage);
        }
    }

    private hentData(): void {
        this.vm$ = this.tilknytForbrugerSandbox.hentViewModel().pipe(shareReplay(1));
    }
}
